/**
 * Le seul endroit qui sait où joindre l'API — et il y a deux réponses.
 *
 * Dans Discord, tout passe par le proxy : `/.proxy/backend/…`, réécrit vers
 * `backend.popmovie.fr` d'après les URL Mappings du Developer Portal. Le
 * navigateur voit du même domaine, donc aucun CORS ne s'applique. La forme
 * exacte (préfixe retiré) a été établie par le spike, pas supposée.
 *
 * Au navigateur, pendant le développement, c'est le proxy de Vite qui relaie :
 * un appel direct serait refusé par le CORS du site, qui n'autorise que
 * `popmovie.fr`. Ainsi le même code marche des deux côtés sans condition
 * disséminée partout.
 */

export const DANS_DISCORD = window.location.hostname.endsWith('discordsays.com');

export const BASE_API = DANS_DISCORD ? '/.proxy/backend/api' : '/api';

/** L'URL WebSocket de Reverb, à travers le proxy quand il y en a un. */
export const chemin_ws = () => (DANS_DISCORD ? '/.proxy/ws' : '');

let jeton = null;

export function definirJeton(valeur) {
  jeton = valeur || null;
}

export function jetonCourant() {
  return jeton;
}

class ErreurApi extends Error {
  constructor(message, statut) {
    super(message);
    this.statut = statut;
  }
}

async function requete(methode, chemin, corps) {
  const entetes = { Accept: 'application/json' };
  if (corps !== undefined) entetes['Content-Type'] = 'application/json';
  if (jeton) entetes['X-Admin-Token'] = jeton;

  let reponse;

  try {
    reponse = await fetch(`${BASE_API}${chemin}`, {
      method: methode,
      headers: entetes,
      body: corps !== undefined ? JSON.stringify(corps) : undefined,
    });
  } catch (erreur) {
    // Distinguer « le réseau a lâché » de « le site a répondu non » : ce sont
    // deux messages différents à l'écran, et deux causes sans rapport.
    throw new ErreurApi(`Le site est injoignable (${erreur.message})`, 0);
  }

  const donnees = await reponse.json().catch(() => ({}));

  if (!reponse.ok) {
    throw new ErreurApi(
      donnees.message || donnees.error || `Erreur HTTP ${reponse.status}`,
      reponse.status,
    );
  }

  return donnees;
}

export const api = {
  get: (chemin) => requete('GET', chemin),
  post: (chemin, corps) => requete('POST', chemin, corps),
};

/**
 * L'URL de lecture d'un film. Le jeton voyage en paramètre : une balise
 * `<video>` ne pose pas d'en-têtes, c'est pour ça que le site a une route
 * dédiée avec son propre garde (`StreamTokenAuth`).
 */
export function urlDuFlux(movieId) {
  return `${BASE_API}/stream/${encodeURIComponent(movieId)}?token=${encodeURIComponent(jeton ?? '')}`;
}

/**
 * Le manifeste d'un direct.
 *
 * Le chemin vient du serveur (`/live/{slug}/index.m3u8`) plutôt que d'être
 * reconstruit ici : c'est lui qui décide de la forme de ses adresses, et
 * l'Activity n'a pas à connaître la notion de slug.
 *
 * Le jeton voyage en paramètre, comme pour un film, et le serveur le reporte
 * lui-même sur chaque segment listé dans le manifeste — le lecteur les
 * demandera relativement, sans avoir l'occasion d'y ajouter quoi que ce soit.
 */
export function urlDuDirect(playlist) {
  return `${BASE_API}${playlist}?token=${encodeURIComponent(jeton ?? '')}`;
}

export { ErreurApi };
